import type { DefaultTranslation } from '@italia/i18n';

const translation: DefaultTranslation = {
  $code: 'en',
  $name: 'English',
  $dir: 'ltr',

  // splide i18n — English defaults
  carousel_prev: 'Previous slide',
  carousel_next: 'Next slide',
  carousel_first: 'Go to first slide',
  carousel_last: 'Go to last slide',
  carousel_slideX: 'Go to slide %s',
  carousel_pageX: 'Go to page %s',
  carousel_play: 'Start autoplay',
  carousel_pause: 'Pause autoplay',
  carousel_carousel: 'carousel',
  carousel_select: 'Select a slide to show',
  carousel_slide: 'slide',
  carousel_slideLabel: '%s of %s',
  carousel_startautoplay: 'Start autoplay',
  carousel_stopautoplay: 'Stop autoplay',
};

export default translation;
